import React from 'react'

import { SxProps } from '@mui/material'

import AvatarGroup from 'components_new/molecules/AvatarGroup'

import { useTranslation } from 'language/translator'

import { formatGroupOption } from 'utils/functions'

import { TGroup } from 'types/GlobalGroup'

interface Props {
  groups: Omit<TGroup, 'key_metrics'>[] // @TODO!
  onClick?: () => void
  sx?: SxProps
}

const GroupsChip = React.memo((props: Props) => {
  const { groups, onClick, sx } = props

  const { t } = useTranslation()

  return (
    <AvatarGroup
      emptyIcon={{ name: 'Groups' }}
      items={groups.map((group) => formatGroupOption(group, t))}
      onClick={onClick}
      tooltip={`${t('global', 'show')} ${t('global', 'groups', true)}`}
      sx={sx}
    />
  )
})

export default GroupsChip
